/* eslint-disable func-names,arrow-body-style  */

import _ from 'lodash';
import saveAs from 'file-saver';
import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { search } from '../../utils/index';

import {
  spottingGroupFetchAll,
  spottingGroupFetchRecord,
  spottingGroupAddRecord,
  spottingGroupRemoveRecords,
} from '../models/SpottingGroup';

import { providers } from './spottingGroupReducers';
import SpottingGroup from '../models/SpottingGroupRecord';

/* eslint-disable arrow-body-style */
import {
  SPOTTING_GROUP_FETCH_TERMS,
  SPOTTING_GROUP_SET_CURRENT_TERM_NAME,
  SPOTTING_GROUP_DOWNLOAD_GROUP,
  SPOTTING_GROUP_SET_CURRENT_TERM,
  SPOTTING_GROUP_SET_CURRENT_TERM_WORDS,
  SPOTTING_GROUP_SET_TERM_IDS,
  SPOTTING_GROUP_SET_LIST_STATE_LOADING,
  SPOTTING_GROUP_SET_LIST_STATE_LOADED,
  SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR,
  SPOTTING_GROUP_SET_EDITING_STATE_LOADING,
  SPOTTING_GROUP_SET_EDITING_STATE_LOADED,
  SPOTTING_GROUP_EDITING_SET_EDIT_WORDS,
  SPOTTING_GROUP_EDITING_SET_SEARCH_TERM,
  SPOTTING_GROUP_DELETE_CHECKED_LISTS,
  SPOTTING_GROUP_LIST_STATE_LOADING,
  SPOTTING_GROUP_LIST_STATE_NOT_LOADED,
  SPOTTING_GROUP_SET_EDITING_TERM_NAME,
  SPOTTING_GROUP_START_ADDING_GROUP,
  SPOTTING_GROUP_ADDING_GROUP_RESET,
  SPOTTING_GROUP_STOP_ADDING_GROUP,
  SPOTTING_GROUP_ADD_NEW_GROUP, SPOTTING_GROUP_SET_LIST_EDIT_STATE,
} from './spottingGroupConstants';

import {
  MODEL_SPOTTING_GROUP_SET_RECORDS,
  MODEL_SPOTTING_GROUP_IDENTITY,
  MODEL_SPOTTING_GROUP_REMOVE_RECORD,
  MODEL_SPOTTING_GROUP_ADD_RECORDS,
  MODEL_SPOTTING_GROUP_ADD_RECORD,
  MODEL_SPOTTING_GROUP_REMOVE_RECORDS,
} from '../models/SpottingGroup/spottingGroupConstants';


export default (bottle) => {
  bottle.factory('fetchTerms', () => {
    return function* fetchTerms() {
      yield put({ type: SPOTTING_GROUP_SET_LIST_STATE_LOADING });
      try {
        const [token] = yield select((state) => {
          return [
            _.get(state, 'users.ephemeralKey.bearerToken'),
          ];
        });

        if (!token) {
          yield put({ type: SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR, payload: 'no token' });
          return;
        }
        const payload = yield call(spottingGroupFetchAll, token);
        const ids = _.map(payload, MODEL_SPOTTING_GROUP_IDENTITY);

        yield put({ type: MODEL_SPOTTING_GROUP_SET_RECORDS, payload });
        yield put({
          type: SPOTTING_GROUP_SET_TERM_IDS,
          payload: ids,
        });
        yield put({ type: SPOTTING_GROUP_SET_LIST_STATE_LOADED });
      } catch (err) {
        yield put({ type: SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR });
      }
    };
  });

  bottle.factory('spottingGroupHandlerDownloadGroupCSV', () => {
    return function* spottingGroupHandlerDownloadGroupCSV(input) {
      const name = _.get(input, 'payload.groupName');
      const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });
      if (!token) return;
      try {
        const data = yield call(spottingGroupFetchRecord, name, token);
        const file = new Blob([new SpottingGroup(data).toCSV()], { type: 'text/csv;charset=utf-8' });
        saveAs(file, `${name}.csv`);
      } catch (err) {
        console.log('error: ', err);
      }
    };
  });

  bottle.factory('spottingGroupHandlerAddGroup', () => {
    return function* addGroup({ payload: newGroup }) {
      const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (!token) {
        yield put({ type: SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR, payload: 'no token' });
      } else {
        yield call(spottingGroupAddRecord, newGroup, token);
      }
      // @TOD: state;
      yield put({ type: SPOTTING_GROUP_FETCH_TERMS });
      yield put({ type: SPOTTING_GROUP_ADDING_GROUP_RESET });
      yield put({ type: SPOTTING_GROUP_STOP_ADDING_GROUP });
    };
  });


  /**
   *  const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });


   */

  bottle.factory('deleteVocabularies', () => {
    return function* deleteVocabularies() {
      const [listChecklist, token] = yield select((state) => {
        return [
          _.get(state, 'spottingGroup.listChecklist'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (token && listChecklist && Array.isArray(listChecklist)) {
        yield call(spottingGroupRemoveRecords, listChecklist, token);
        yield put(providers.setListStateChecks([]));
        yield put({ type: SPOTTING_GROUP_FETCH_TERMS });
      }
    };
  });

  bottle.factory('loadCurrentName', () => {
    return function* loadCurrentName() {
      const [fetchState, termsByID, groupName] = yield select((state) => {
        return [
          _.get(state, 'spottingGroup.listState'),
          _.get(state, 'modelSpottingGroup.modelSpottingGroupById'),
          _.get(state, 'spottingGroup.groupName'),
        ];
      });

      if (fetchState === SPOTTING_GROUP_LIST_STATE_LOADING) {
        return;
      }

      if (!groupName) {
        yield put({ type: SPOTTING_GROUP_SET_CURRENT_TERM, payload: null });
      } else if (fetchState === SPOTTING_GROUP_LIST_STATE_NOT_LOADED) {
        yield put({ type: SPOTTING_GROUP_SET_EDITING_STATE_LOADING });
        yield put({ type: SPOTTING_GROUP_FETCH_TERMS });
      } else {
        const currentTerm = termsByID[groupName];

        yield put({ type: SPOTTING_GROUP_SET_CURRENT_TERM, payload: currentTerm || null });
        yield put({ type: SPOTTING_GROUP_SET_EDITING_STATE_LOADED });
      }
    };
  });

  bottle.factory('spottingGroupHandlerSetTerms', () => {
    return function* () {
      const [currentTerm, currentTermSearch] = yield select((state) => {
        return [
          _.get(state, 'spottingGroup.currentTerm'),
          _.get(state, 'spottingGroup.editingSearch'),
        ];
      });

      // @TODO: filtering terms by search

      if (currentTerm) {
        const words = _.get(currentTerm, 'terms', []);
        const payload = words
          .filter(term => search(currentTermSearch, term));

        yield put({
          type: SPOTTING_GROUP_SET_CURRENT_TERM_WORDS,
          payload,
        });
      } else {
        yield put({ type: SPOTTING_GROUP_SET_CURRENT_TERM_WORDS, payload: [] });
      }
    };
  });

  bottle.factory('spottingGroupHandlerInitEditing', () => {
    return function* () {
      const [isEditing, currentName] = yield select((state) => {
        return [
          _.get(state, 'spottingGroup.isEditingTerms'),
          _.get(state, 'spottingGroup.groupName'),
        ];
      });

      if (isEditing) {
        yield put({ type: SPOTTING_GROUP_SET_EDITING_TERM_NAME, payload: currentName });
      }
    };
  });

  bottle.factory('spottingGroupHandlerInitAddGroup', () => {
    return function* () {
      yield put({ type: SPOTTING_GROUP_ADDING_GROUP_RESET });
    };
  });

  bottle.factory('spottingGroupEditingStartSaga', ({ spottingGroupHandlerInitEditing }) => {
    return function* spottingGroupEditingStartSaga() {
      yield takeLatest([SPOTTING_GROUP_EDITING_SET_EDIT_WORDS], spottingGroupHandlerInitEditing);
    };
  });

  bottle.factory('spottingGroupEditingSearchSaga', ({ spottingGroupHandlerSetTerms }) => {
    return function* spottingGroupEditingSearchSaga() {
      yield takeEvery([
        SPOTTING_GROUP_SET_CURRENT_TERM,
        SPOTTING_GROUP_EDITING_SET_SEARCH_TERM,
      ], spottingGroupHandlerSetTerms);
    };
  });

  bottle.factory('spottingGroupAddGroupSaga', ({ spottingGroupHandlerAddGroup }) => {
    return function* spottingGroupAddGroupSaga() {
      yield takeEvery(SPOTTING_GROUP_ADD_NEW_GROUP, spottingGroupHandlerAddGroup);
    };
  });

  bottle.factory('spottingGroupDeleteGroupSaga', ({ deleteVocabularies }) => {
    return function* spottingGroupDeleteGroupSaga() {
      yield takeEvery(SPOTTING_GROUP_DELETE_CHECKED_LISTS, deleteVocabularies);
    };
  });

  bottle.factory('spottingGroupFetchSaga', ({ fetchTerms }) => {
    return function* spottingGroupFetchSaga() {
      yield takeLatest(SPOTTING_GROUP_FETCH_TERMS, fetchTerms);
    };
  });

  bottle.factory('spottingGroupEditingHandler', () => {
    return function* spottingGroupEditingHandler() {
      // every time the user goes in or out of edit mode, reset the checklist
      yield put(providers.setListStateChecks([]));
    };
  });

  bottle.factory('spottingGroupLoadCurrentNameSaga', ({ loadCurrentName }) => {
    return function* spottingGroupEditingStartSaga() {
      yield takeEvery(
        [
          MODEL_SPOTTING_GROUP_SET_RECORDS,
          MODEL_SPOTTING_GROUP_REMOVE_RECORD,
          MODEL_SPOTTING_GROUP_ADD_RECORDS,
          MODEL_SPOTTING_GROUP_ADD_RECORD,
          MODEL_SPOTTING_GROUP_REMOVE_RECORDS,
          SPOTTING_GROUP_SET_LIST_STATE_LOADED,
          SPOTTING_GROUP_SET_CURRENT_TERM_NAME,
        ],
        loadCurrentName,
      );
    };
  });

  bottle.factory('spottingGroupStartAddingGroupSaga', ({ spottingGroupHandlerInitAddGroup }) => {
    return function* spottingGroupStartAddingGroupSaga() {
      yield takeEvery(
        SPOTTING_GROUP_START_ADDING_GROUP,
        spottingGroupHandlerInitAddGroup,
      );
    };
  });

  bottle.factory('spottingGroupStartEditingSaga', ({ spottingGroupEditingHandler }) => {
    return function* spottingGroupStartEditingSaga() {
      yield takeEvery(
        SPOTTING_GROUP_SET_LIST_EDIT_STATE,
        spottingGroupEditingHandler,
      );
    };
  });

  bottle.factory('spottingGroupDownloadGroupCSVSaga', ({ spottingGroupHandlerDownloadGroupCSV }) => {
    return function* spottingGroupCSVSaga() {
      yield takeEvery(
        SPOTTING_GROUP_DOWNLOAD_GROUP,
        spottingGroupHandlerDownloadGroupCSV,
      );
    };
  });
};
